import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	imageIcon: {
		height : "4rem",
		width  : "4rem"
	},
	imageContainer: {
		width          : "100%",
		display        : "flex",
		justifyContent : "center",
		alignItems     : "center",
		background     : theme.other.paletteNew.darkModeDarkGrey20,
		aspectRatio    : props?.aspectRatio || "16/9",
		borderRadius   : "1rem"
	}
} ), { name: "uploadThumbnailSkeleton" } );
